import {
  GET_PIMADATA,
  GET_PIMADATA_FEB_2021,
  GET_PIMADATA_JAN_2021,
  GET_PIMADATA_DEC_2020,
  GET_PIMADATA_NOV_2020,
  GET_PIMADATA_OCT_2020,
  GET_PIMADATA_SEP_2020,
  GET_PIMADATA_AGO_2020,
  GET_PIMADATA_JUL_2020,
  GET_PIMADATA_JUN_2020,
  GET_PIMADATA_MAY_2020,
  GET_PIMADATA_APR_2020,
  GET_PIMADATA_MAR_2020,
  GET_PIMADATA_AGO_2021,
  GET_PIMADATA_APR_2021,
  GET_PIMADATA_DEC_2021,
  GET_PIMADATA_JUL_2021,
  GET_PIMADATA_JUN_2021,
  GET_PIMADATA_MAR_2021,
  GET_PIMADATA_MAY_2021,
  GET_PIMADATA_NOV_2021,
  GET_PIMADATA_OCT_2021,
  GET_PIMADATA_SEP_2021,
} from "./types";
import api from "../utils/api";

export const getPimaData = (select) => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?sort=date.year,date.month,date.day${select}`
    );
    dispatch({
      type: GET_PIMADATA,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataDec2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=12&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_DEC_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataNov2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=11&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_NOV_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataOct2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=10&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_OCT_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataSep2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=9&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_SEP_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataAgo2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=8&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_AGO_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataJul2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=7&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_JUL_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataJun2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=6&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_JUN_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataMay2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=5&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_MAY_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataApr2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=4&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_APR_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataMar2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=3&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_MAR_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataFeb2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=2&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_FEB_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataJan2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2021&date.month=1&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_JAN_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataDec2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=12&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_DEC_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataNov2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=11&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_NOV_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataOct2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=10&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_OCT_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataSep2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=9&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_SEP_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataAgo2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=8&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_AGO_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataJul2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=7&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_JUL_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataJun2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=6&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_JUN_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataMay2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=5&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_MAY_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataApr2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=4&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_APR_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPimaDataMar2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `pimadatas?date.year=2020&date.month=3&sort=date.day`
    );
    dispatch({
      type: GET_PIMADATA_MAR_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
